<template>
  <div>
    <div class="columns is-gapless is-border-bottom has-bg-white">
      <div @click="toggleProcedure()"
           class="column is-narrow has-bg-white is-border-right is-border-left is-flex is-padding-small">
        <span class="icon is-self-centered"><i class="fal"
                                               :class="open ? 'fa-chevron-down': 'fa-chevron-right'"></i></span>
      </div>
      <div @click="toggleProcedure()" class="column is-self-centered is-padding-left is-padding-right">
        <div
          v-if="procedure.status === 'active' || procedure.status === 'deleted' || procedure.status === 'expired' || procedure.status === 'refused'"
          class="is-size-6 is-uppercase">
          Procédure lancée le {{procedure.created_on | date}}
        </div>
        <div v-if="procedure.status === 'finished'" class="is-size-6 is-uppercase">
          Procédure terminée le {{procedure.updated_on | date}}
        </div>
      </div>
      <div v-if="procedure.status === 'deleted' || procedure.status === 'expired' || procedure.status === 'refused'"
           class="column is-narrow is-flex is-padding-small">
        <span class="has-text-danger is-self-centered is-uppercase is-size-7">
          <span v-if="procedure.status === 'deleted'">Annulée le {{procedure.deleted_on | date}}</span>
          <span v-else-if="procedure.status === 'expired'">Expirée le {{procedure.updated_on | date}}</span>
          <span v-else-if="procedure.status === 'refused'">Refusée le {{procedure.updated_on | date}}</span>
        </span>
      </div>
      <a v-else @click="confirmCancel()" class="column is-narrow has-bg-grey3 is-flex is-padding-small">
        <span class="has-text-dark is-self-centered is-uppercase is-size-7">Annuler procédure</span>
      </a>
    </div>
    <div v-if="open">
      <div v-if="procedure.status === 'active'" class="notification is-success has-text-centered is-marginless">
        <p class="is-uppercase is-size-7">
          <span class="icon"><i class="fas fa-check-square"></i></span>
          <span class="has-text-weight-medium">Procédure activée : </span>un email d'invitation a été envoyé aux signataires
        </p>
      </div>
      <div
        v-else-if="procedure.status === 'deleted' || procedure.status === 'expired' || procedure.status === 'refused'"
        class="notification is-warning has-text-centered is-marginless">
        <p class="is-uppercase is-size-7">
          <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
          <span v-if="procedure.status === 'refused'" class="has-text-weight-medium">Procédure refusée</span>
          <span v-else class="has-text-weight-medium">Procédure annulée :</span>
          <span v-if="isUserDelete">
            <span v-if="user.is_admin">annulée par admin</span>
            <span v-else>annulée par vendeur</span>
          </span>
          <span v-else>
            <span v-if="procedure.status === 'expired'">delais expiré</span>
          </span>
        </p>
      </div>
      <div v-if="procedure.deleted_reason">
        <div>
          <div class="vadDiscussion is-border-top">
            <div class="vadDiscussion--bulle is-size-6 vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div class="is-margin-bottom-xxsmall">
                <span class="is-size-7">
                  <b>Date : </b>{{procedure.deleted_on |date}} -<b data-v-648c4338="">Auteur : </b>
                  <span>{{user.first_name}} <span class="is-uppercase">{{user.last_name}}</span></span>
                  <span v-if="user.is_admin">(admin)</span>
                  <span v-else>(vendeur)</span>
                </span>
              </div>
              <div data-v-648c4338="" class="content">
                <p v-html="procedure.deleted_reason"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-bg-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
        <span class="is-uppercase title is-6">Signature réservataire / acquéreur</span>
      </div>
      <!----------------- CONTRAT ACQUEREUR --------------->
      <template v-for="(membre, idx) in membresBuyer">
        <div :key="idx" class="is-margin-bottom-xsmall is-border">
          <contrat-item :membre="membre" :idx="idx" :procedure="procedure" :signatures="signatures"
                        @commitAdv='commitAdv'></contrat-item>
        </div>
      </template>
      <!----------------- CONTRAT PROMOTEUR --------------->
      <div class="is-border is-margin-bottom-xsmall">
        <div class="columns is-gapless has-bg-white">
          <div class="column is-narrow is-flex is-padding-small"
               :class="membrePromoteur.status === 'pending' || membrePromoteur.status === 'refused' ? 'has-bg-grey3 is-border-right' : 'has-bg-success'">
            <span class="icon is-self-centered"
                  :class="membrePromoteur.status === 'pending' || membrePromoteur.status === 'refused' ? 'has-text-danger' : 'has-text-white'">
              <i v-if="membrePromoteur.status === 'pending'" class="fas fa-clock"></i>
              <i v-else-if="membrePromoteur.status === 'refused'" class="fas fa-exclamation-circle"></i>
              <i v-else class="fas fa-check-circle"></i>
              </span>
          </div>
          <div class="column columns is-gapless is-padding-small is-multiline">
            <div class="column is-6 is-4-widescreen is-3-fullhd is-padding-xxsmall">
              <div class="label">
                <span>RÉSERVANT / PROMOTEUR</span>
              </div>
              <div class="title is-5">
                <span class="is-uppercase">{{membrePromoteur.last_name}}</span>
                <span>{{membrePromoteur.first_name}}</span>
              </div>
            </div>
            <div class="column is-6 is-4-widescreen is-3-fullhd is-padding-xxsmall">
              <div class="label">
                <span>Adresse</span>
              </div>
              <div class="title is-5" v-if="membrePromoteur && membrePromoteur.address">
                <span v-if="membrePromoteur.address.line1">{{membrePromoteur.address.line1}}</span>
                <br v-if="membrePromoteur.address.line1">
                <span v-if="membrePromoteur.address.zip_code || membrePromoteur.address.city">{{membrePromoteur.address.zip_code}} {{membrePromoteur.address.city}}</span>
                <br v-if="membrePromoteur.address.zip_code || membrePromoteur.address.city">
                <span v-if="membrePromoteur.address.country">{{membrePromoteur.address.country}}</span>
                <span v-if="!membrePromoteur.address.line1 && !membrePromoteur.address.zip_code &&
                        !membrePromoteur.address.country && !membrePromoteur.address.city">
              NC
            </span>
              </div>
            </div>
            <div class="column is-12 is-4-widescreen is-6-fullhd columns is-gapless is-multiline">
              <div class="column is-6 is-12-widescreen is-6-fullhd is-padding-xxsmall">
                <div class="label">
                  <span>Téléphone</span>
                </div>
                <div class="title is-5">
                  {{membrePromoteur.phone}}
                </div>
              </div>
              <div class="column is-6 is-12-widescreen is-6-fullhd is-padding-xxsmall">
                <div class="label">
                  <span>Mail</span>
                </div>
                <div class="title is-5">
                  <span>{{membrePromoteur.email}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if='membrePromoteur.comment' class="columns is-gapless has-bg-warning is-border-top is-padding-small">
          <div class="column is-12 is-padding-left-large">
            <div class="is-uppercase is-size-6"><b>PROCÉDURE ANNULÉE : Commentaires</b></div>
            <div class="is-padding-top-small is-size-6">{{membrePromoteur.comment}}</div>
            <div class="is-uppercase is-padding-top-small is-size-6"><span><b>Date :</b></span>
              {{membrePromoteur.updated_on | dateRefus}}
            </div>
          </div>
        </div>
        <div v-if="(isAdmin || isSectorManager) && membrePromoteur.status !== 'refused' && procedure.status !== 'deleted'"
          class="is-padding-bottom-small columns is-border-top is-gapless is-centered has-bg-white is-padding-top-small ">
          <div class="column is-4 is-margin-left-small">
            <a v-if="!canSign" :disabled="true"
               class="button is-small is-success is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Signer contrat</span>
              </div>
            </a>
            <a v-else-if="membrePromoteur.status === 'done'" @click="openPreviewContratMembre()"
               class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </a>
            <a v-else-if="procedure.statut === 'finished'" @click="openPreviewContrat()"
               class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </a>
            <a v-else @click="openPreview(membrePromoteur)"
               class="button is-small is-success is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Signer contrat</span>
              </div>
            </a>
          </div>
        </div>
        <div v-if="!(isAdmin || isSectorManager) && membrePromoteur.status !== 'refused' && procedure.status !== 'deleted' && (membrePromoteur.status === 'done' || procedure.statut === 'finished')"
          class="is-padding-bottom-small columns is-border-top is-gapless is-centered has-bg-white is-padding-top-small ">
          <div class="column is-4 is-margin-left-small">
            <a v-if="membrePromoteur.status === 'done'" @click="openPreviewContratMembre()"
               class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </a>
            <a v-else-if="procedure.statut === 'finished'" @click="openPreviewContrat()"
               class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- <div v-if="procedure.status === 'finished'"
           class="is-padding-bottom-small columns is-border-top is-gapless is-centered has-bg-white is-padding-top-small ">
        <div class="column is-4 is-margin-left-small">
          <a @click="openPreviewContrat()" class="button is-small is-success is-transform-none is-fullwidth is-radius">
            <div class="veryFastAnimation">
              <span>Voir le contrat signé</span>
            </div>
          </a>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { isEmpty } from 'lodash'
  import contratItem from './ContratItem'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'ProcedureItem',
    components: { contratItem },
    props: {
      source: {
        type: Object,
        default: () => {}
      },
      signatures: Array
    },
    data () {
      return {
        user: {},
        open: false
      }
    },
    filters: {
      date: function (value) {
        let date = moment(value).format('DD/MM/YYYY')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')

        return date + ' à ' + hour + 'h' + minute
      },
      dateRefus: function (value) {
        let date = moment(value).format('DD/MM/YYYY')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')

        return date + ' - ' + hour + ':' + minute
      }
    },
    watch: {
      modal ({ mode, params, results }) {
        if (results) {
          if (mode === 'CANCEL_PROCEDURE' && params.procedure === this.procedure.pk) {
            if (results.cancel) {
              this.cancel()
            } else {
              this.cancel(results)
            }
            // let adv = Object.assign({}, this.adv)
            // this.$set(adv, 'promoteur_contact', results)
            // this.$emit('commit', adv)
          }
        }
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isSectorManager']),
      ...mapState(['configs', 'modal']),
      yousignSignatureUrl () {
        return this.configs.YOUSIGN_URL
      },
      yousignSignatureId () {
        return this.configs.YOUSIGN_SIGNATURE_ID
      },
      procedure () {
        return this.source
      },
      isUserDelete () {
        return !isEmpty(this.user)
      },
      membresBuyer () {
        let array = []
        this.procedure.members.find(x => {
          if (x.is_buyer || x.is_cobuyer) array.push(x)
        })
        return array
      },
      membrePromoteur () {
        return this.procedure.members.find(x => {
          return x.is_promoteur
        })
      },
      everyBodySign () {
        let contratSign = []
        this.procedure.members.forEach(x => {
          if (x.status === 'done') contratSign.push(x.status)
        })
        return contratSign.length === this.procedure.members.length
      },
      canSign () {
        let nbrPending = this.procedure.members.filter(x => {
          return x.status === 'pending'
        })
        nbrPending = nbrPending.length
        if (nbrPending === 1) return true
        else if (this.everyBodySign) return true
        else return false
      }
    },
    methods: {
      openPreview (elem) {
        let params = {
          link: this.yousignSignatureUrl + '/procedure/sign?members=/members/' + elem.yousign_id
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
      },
      openPreviewContrat () {
        const apiUrl = this.$configs.APIROOT
        let link = document.createElement('a')
        link.href = apiUrl + '/yousign-file/' + this.procedure.file_id
        link.target = '_blank'
        link.click()
        // let params = {
        //   youSign: '/yousign-file/' + this.membre.file_id,
        // }
        // this.$store.commit('setModal', {mode: 'DOCUMENT_PREVIEW', params})
      },
      openPreviewContratMembre () {
        const apiUrl = this.$configs.APIROOT
        let link = document.createElement('a')
        link.href = apiUrl + '/yousign-file/' + this.membrePromoteur.file_id
        link.target = '_blank'
        link.click()
      },
      commitAdv () {
        this.$emit('commitAdv')
      },
      toggleProcedure () {
        this.open = !this.open
      },
      confirmCancel () {
        let params = {
          procedure: this.procedure.pk
        }
        this.$store.commit('setModal', { mode: 'CANCEL_PROCEDURE', params })
      },
      cancel (result = null) {
        let params = {}
        if (result) {
          this.$set(this.procedure, 'deleted_reason', result)
          params = {
            status: 'deleted',
            deleted_reason: this.procedure.deleted_reason
          }
        } else {
          params = {
            status: 'deleted'
          }
        }
        this.$api.advService.deleteProcedure(this.procedure.adv, this.procedure.pk, params).then(result => {
          let newProcedure = Object.assign({}, result.data)
          this.$emit('updateProcedure', newProcedure)
          this.$notify({
            type: 'is-success',
            text: 'Procedure annulée'
          })
          if (result.data.deleted_by) {
            this.getUser(result.data)
          }
        })
      },
      getUser (procedure) {
        this.$api.userService.getOne(procedure.deleted_by).then(r => {
          this.user = r.data
        })
      }
    },
    created (procedure) {
      if (this.procedure.status === 'active' || this.procedure.status === 'finished') {
        this.open = true
      }
      if (this.procedure.deleted_by) {
        this.getUser(this.procedure)
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/ProcedureItem.vue